import React from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { Container, Grid, Box, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LazyImage from "./App/LazyImage";
import {getContent} from "../actions/content";
import {connect} from 'react-redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {slugify} from "../utils";

import Card from '@material-ui/core/Card';
import Carousel from "./Carousel";
import {formatDate} from "../utils";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} maxWidth={1000} mx="auto">
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const tabs = [
    {
        index: 0,
        title: 'News Coverage',
    }, {
        index: 1,
        title: 'Press Release'
    }, {
        index: 2,
        title: 'Resources'
    }, {
        index: 3,
        title: 'Creatives & Ads'
    }, {
        index: 4,
        title: 'Culture'
    }
];

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    listItemRoot: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    resourceCard: {
        marginBottom: theme.spacing(3),
        '& a': {
            color: theme.palette.secondary.main
        }
    },
    sidebar: {
        maxWidth: '240px',
        margin: `${theme.spacing(2)}px auto 0`,
        [theme.breakpoints.up('sm')]: {
            marginTop: 0
        }
    },
    traeImage: {
        borderRadius: '50%',
        border: `solid 1px ${theme.palette.secondary.main}`,
        display: 'block',
        margin: `0 auto ${theme.spacing(1)}px`
    },
    resourceImage: {
        width: '100%',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        paddingBottom: '60%',
        [theme.breakpoints.up('sm')]: {
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
        }
    }
}));

const PressAndMediaPage = ({getContent, content = {}}) => {
    let history = useHistory();
    let location = useLocation();
    const classes = useStyles();
    const [pageTabValue, setPageTabValue] = React.useState(0);
    const [tabViewable, setTabViewable] = React.useState(false);

    const get = (property) => {
        return (content && content[property]) ? content[property] : '';
    };

    React.useEffect(() => {
        getContent('Press & Media');
        for (let i = 0; i < tabs.length; i++) {
            if (location.pathname === `/press/${slugify(tabs[i].title)}`) {
                setPageTabValue(tabs[i].index);
            }
        }
        setTabViewable(true);
        // eslint-disable-next-line
    }, []);

    const handlePageTabChange = (event, newValue) => {
        setPageTabValue(newValue);
        history.push(`/press/${slugify(tabs[newValue].title)}`);
    };

    const news = [];
    Array.apply(0, Array(100)).map(function (x, i) {
        if (get(`News_Coverage_${i}_-_Description`)) {
            news.push({
                description: get(`News_Coverage_${i}_-_Description`),
                date: Date.parse(get(`News_Coverage_${i}_-_Date`)),
                link: get(`News_Coverage_${i}_-_Link`),
                outlet: get(`News_Coverage_${i}_-_News_Outlet`)
            });
        }
        return '';
    });

    const press = [];
    Array.apply(0, Array(100)).map(function (x, i) {
        if (get(`Press_Release_${i}_-_Title`)) {
            press.push({
                title: get(`Press_Release_${i}_-_Title`),
                date: Date.parse(get(`Press_Release_${i}_-_Date`)),
                link: get(`Press_Release_${i}_-_Link`),
                description: get(`Press_Release_${i}_-_Description`)
            });
        }
        return '';
    });

    const creativesCarouselSteps = [];
    Array.apply(0, Array(100)).map(function (x, i) {
        if (get(`Creatives_${i}_THUMBNAIL_URL`)) {
            creativesCarouselSteps.push({
                imgPath: get(`Creatives_${i}_THUMBNAIL_URL`),
                type: get(`Creatives_${i}_YOUTUBE_VIDEO_ID`) ? 'video' : 'image'
            });
        }
        return '';
    });

    const cultureCarouselSteps = [];
    Array.apply(0, Array(100)).map(function (x, i) {
        if (get(`Culture_${i}_THUMBNAIL_URL`)) {
            cultureCarouselSteps.push({
                imgPath: get(`Culture_${i}_THUMBNAIL_URL`),
                type: get(`Culture_${i}_YOUTUBE_VIDEO_ID`) ? 'video' : 'image'
            });
        }
        return '';
    });

    const resources = [];
    Array.apply(0, Array(100)).map(function (x, i) {
        if (get(`Resource_${i}_-_Image_Source`)) {
            resources.push({
                imgPath: get(`Resource_${i}_-_Image_Source`),
                imgAlt: get(`Resource_${i}_-_Image_Alt`),
                imgTitle: get(`Resource_${i}_-_Image_Title`),
                heading: get(`Resource_${i}_-_Heading`),
                preview: get(`Resource_${i}_-_Preview`),
                video: get(`Resource_${i}_-_Video_Embed`)
            });
        }
        return '';
    });

    return (
        <div className={classes.root}>
            <Box maxWidth={850} ml="auto" mr="auto" mb={2} pt={4}>
                <Container>
                    <AppBar position="static" color="inherit" elevation={0}>
                        <Tabs
                            value={pageTabValue}
                            onChange={handlePageTabChange}
                            scrollButtons="auto"
                            indicatorColor="secondary"
                            textColor="primary"
                            variant="scrollable"
                            aria-label="scrollable auto tabs example"
                        >
                            {tabs.map(tab => (
                                <Tab key={tab.index} label={tab.title} {...a11yProps(tab.index)} />
                            ))}
                        </Tabs>
                    </AppBar>
                </Container>
            </Box>

            {tabViewable && (
                <>
                    <TabPanel value={pageTabValue} index={0}>
                        <Typography color="secondary" variant="h3" align="center">News Coverage</Typography>
                        <Typography component="div" dangerouslySetInnerHTML={{__html: get('News_Coverage_-_Introduction')}} />
                        <List className={classes.listItemRoot}>
                            {news.sort((a,b) => b.date - a.date).map((newsItem, key) => (
                                <React.Fragment key={key}>
                                    {key > 0 && <Divider style={{marginLeft: '40px'}} variant="inset" component="li" />}
                                    <ListItem alignItems="flex-start">
                                        <Box color="secondary.main" my={1} mr={2}>&bull;</Box>
                                        <ListItemText
                                            primary={<><Box component="span" color="primary.main"><Link target="_blank" rel="noreferrer noopener" href={newsItem.link}>{newsItem.outlet}</Link></Box>{" "}<small>{formatDate(newsItem.date, 'mm/dd/yyyy')}</small></>}
                                            secondary={newsItem.description}
                                        />
                                    </ListItem>
                                </React.Fragment>
                            ))}
                        </List>
                    </TabPanel>
                    <TabPanel value={pageTabValue} index={1}>
                        <Typography color="secondary" variant="h3" align="center">Press Release</Typography>
                        <Typography component="div" dangerouslySetInnerHTML={{__html: get('News_Coverage_-_Introduction')}} />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <Box className={classes.sidebar}>
                                    <LazyImage width="162px" height="162px" className={classes.traeImage} src={get('Press_Release_-_Sidebar_-_Image_-_URL')} />
                                    <Typography align="center" variant="h5" color="secondary">{get('Press_Release_-_Sidebar_-_Heading')}</Typography>
                                    <Divider color="secondary" />
                                    <Typography align="center"><small>{get('Press_Release_-_Sidebar_-_Content')}</small></Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                                <List className={classes.listItemRoot}>
                                    {press.sort((a,b) => b.date - a.date).map((pressItem, key) => (
                                        <React.Fragment key={key}>
                                            {key > 0 && <Divider style={{marginLeft: '40px'}} variant="inset" component="li" />}
                                            <ListItem alignItems="flex-start">
                                                <Box color="secondary.main" my={1} mr={2}>&bull;</Box>
                                                <ListItemText
                                                    primary={<><Box component="span" color="primary.main">
                                                        <Link target="_blank" rel="noreferrer noopener" href={pressItem.link}>{pressItem.title}</Link>
                                                    </Box>{" "}<small>{formatDate(pressItem.date, 'mm/dd/yyyy')}</small></>}
                                                    secondary={pressItem.description}
                                                />
                                            </ListItem>
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={pageTabValue} index={2}>
                        <Box mb={8}>
                            <Typography color="secondary" variant="h3" align="center">Resources</Typography>
                            <Typography component="div" dangerouslySetInnerHTML={{__html: get('News_Coverage_-_Introduction')}} />
                        </Box>
                        {resources.map((resource, key) => (
                            <Card elevation={3} key={key} className={classes.resourceCard}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={5} style={{position: 'relative'}}>
                                        <div className={classes.resourceImage} style={{backgroundImage: `url(${resource.imgPath})`}} />
                                    </Grid>
                                    <Grid item xs={12} sm={7}>
                                        <Box p={2}>
                                            <Typography variant="h3">{resource.heading}</Typography>
                                            <Typography component="div" dangerouslySetInnerHTML={{__html: resource.preview}} />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                    </TabPanel>
                    <TabPanel value={pageTabValue} index={3}>
                        <Box mb={4}>
                            <Typography color="secondary" variant="h3" align="center" dangerouslySetInnerHTML={{__html: get('Creatives_-_Heading')}} />
                            <Typography component="div" dangerouslySetInnerHTML={{__html: get('Creatives_-_Introduction')}} />
                        </Box>
                        {creativesCarouselSteps.length > 0 && (
                            <Carousel steps={creativesCarouselSteps}/>
                        )}
                    </TabPanel>
                    <TabPanel value={pageTabValue} index={4}>
                        <Box mb={4}>
                            <Typography color="secondary" variant="h3" align="center" dangerouslySetInnerHTML={{__html: get('Culture_-_Heading')}} />
                            <Typography component="div" dangerouslySetInnerHTML={{__html: get('Culture_-_Introduction')}} />
                        </Box>
                        {cultureCarouselSteps.length > 0 && (
                            <Carousel steps={cultureCarouselSteps}/>
                        )}
                    </TabPanel>
                </>
            )}
        </div>
    );
}

export default connect(
    (state) => ({
        content: state.content.content,
    }),
    { getContent }
)(PressAndMediaPage);